
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';

import {
  SiteMapSectionData,
  SiteMapSectionMethods,
  SiteMapSectionComputed,
  SiteMapSectionProps,
} from './SiteMapSection';
import {
  MediaQueryService,
  WB_RESIZE_EVENT_NAME,
  mobileBreakpoints,
  tabletBreakpoints,
} from '@owc-utils/MediaQueryService';
// Importing MediaQueryChangeEvent type declaration
import { MediaQueryChangeEvent } from '@owc-utils/MediaQueryService/MediaQueryChangeEvent';
import { isEdit } from './Footer.config';

/**
 * `SiteMapSection Footer` - SiteMapSection for OneWeb - This component contains the sitemap of the website, splited by topics.
 */

export default ComponentInitializeDispatcher.extend<
  SiteMapSectionData,
  SiteMapSectionMethods,
  SiteMapSectionComputed,
  SiteMapSectionProps
>({
  name: 'owc-site-map-section',
  props: {
    siteMapSection: {
      type: Object,
    },
  },
  data() {
    return {
      active: false,
      wbMediaQueryService: new MediaQueryService(window),
      isMobile: true,
    };
  },
  mounted(): void {
    // Used to change image ratio given a MediaQuery Event
    window.addEventListener(
      WB_RESIZE_EVENT_NAME,
      this.resizeEventHandler as EventListenerOrEventListenerObject,
    );
    this.wbMediaQueryService.observe(true);
  },
  beforeDestroy(): void {
    window.removeEventListener(
      WB_RESIZE_EVENT_NAME,
      this.resizeEventHandler as EventListenerOrEventListenerObject,
    );
  },
  computed: {
    title: function() {
      return isEdit ? this.componentData?.title : this.siteMapSection?.title;
    },
    links: function() {
      return isEdit ? this.componentData?.links : this.siteMapSection?.links;
    },
    visible: function() {
      return this.active;
    },
  },
  methods: {
    open() {
      this.active = !this.active;
    },
    start(el: HTMLElement) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el: HTMLElement) {
      el.style.height = '';
    },
    resizeEventHandler(resizeEvent: CustomEvent<MediaQueryChangeEvent>) {
      this.isMobile = [...mobileBreakpoints, ...tabletBreakpoints].includes(resizeEvent.detail.current);
    },
  },
});
